<template>

  <div class="aboutwes">
    <!-- <a class="aaaaaa" href="/aboutwe#a" style="font-size: 24px"><div>aaaaaa</div></a> -->
    <div class="aboutwe">
      <!-- <div class="aboutwe_img">
				<img src="../assets/images/paper2.jpeg" alt="" >
			</div> -->
      <!-- <div class="Router_Banner">
				     <a href="/aboutwe#a">拍界简介</a>
				     <a href="/aboutwe#b">企业文化</a>
				     <a href="/aboutwe#c">服务内容</a>
				     <a href="/aboutwe#d">企业荣誉</a>
				     <a href="/aboutwe#e">发展历程</a>
				     <a href="/aboutwe#f">联系我们</a>
				  </div> -->
      <div class="aboutwe_container">
        <h3 class="about-h3" id='a'>拍界简介</h3>

        <div class="jj123">
          <p>拍界（www.paijie.com）是拍界（吉林省）拍卖有限公司旗下在线实时拍卖平台，总部位于吉林省长春市。拍界是利用互联网技术，将传统的拍卖方式与网络结合到一起，为用户提供稳定、便捷的网上竞拍系统，使传统拍卖不再受地域限制，提供废旧行业领域产品的在线送拍、在线竞拍、在线委托出价等现代化便捷的拍卖方式。</p>
           
          <p>拍界在拍卖服务方面有着丰富的专业知识和经验，并与全国上万家大集团企业建立了良好的合作关系，拥有精准的竞买群体，专业化拍卖团队，完备的线下服务体系，致力于为广大从事废旧物资从业者提供拍卖商机。通过对广大行业市场的拓展，拍界在拍卖行业取得了良好口碑，合作伙伴遍布全国各地。以“持续的创新，不断的超越，为用户创造价值，让员工实现梦想”为使命，拍界向着“国际一流拍卖企业”稳步前进。</p>
          <p>拍界拍卖有限公司按照“总体规划、分步实施”的经营策略，全国设立七个大区，积极投身国内的城市化和现代化进程，并有选择的逐步进入海外发达经济体，实现国内市场和国外市场均衡发展。</p>
           
          <p>回顾过去，铿锵有力，步履坚实。</p>
          <p>展望未来，脚踏实地，戮力前行。</p>
          <p>大道至简，实干为要。</p>
        </div>
        <div class="Hui"></div>
        <img src="../assets/images/About_One.png" class="about-im1">

      </div>
      <!-- <div class="aboutwe_container_text1">
				<div class="aboutwe_container_text1_right"><img src="../assets/images/about_6.jpg" alt=""></div>
				<div class="aboutwe_container_text1_left">
				
				</div>
			</div> -->
      <!-- <div class="aboutwe_number">
				<div>
					<div class="aboutwe_number_discribe">5年</div>
					<div>服务经验</div>
				</div>
				<div>
					<div class="aboutwe_number_discribe">10000+</div>
					<div>客户</div>
				</div>
				<div>
					<div class="aboutwe_number_discribe">200</div>
					<div>员工</div>
				</div>
			</div> -->
      <div class="aboutwe_container1">
        <h3 id='b'>企业文化</h3>
        <div class="about-line2"></div>

        <div class="about-con">
          <img id="aa1" src="../assets/images/About_1.png" alt="">
          <img id="aa2" src="../assets/images/About_2.png" alt="">
          <img id="aa3" src="../assets/images/About_3.png" alt="">
          <img id="aa4" src="../assets/images/About_4.png" alt="">
          <img src="../assets/images/About_Two.png" alt="" style="width: 450px;height: 400px; left: 50%;position: absolute;padding:0">

        </div>

        <div class="ct">
          <p class="p1t">企业使命</p>
          <p class="p1c">--帮助企业将废旧设备快速变现</p>
          <p class="p1x"></p>
        </div>
        <div class="ct">
          <p class="p2t">企业前景</p>
          <p class="p2c">--打造中国互联网拍卖第一专业服务平台</p>
          <p class="p2x"></p>
        </div>
        <div class="ct">
          <p class="p3t">核心价值观</p>
          <p class="p3c">--我们一直为客户的效果而努力</p>
          <p class="p3x"></p>
        </div>
        <div class="ct">
          <p class="p4t">企业理念</p>
          <p class="p4c">--以人为本，合作共赢</p>
          <p class="p4x"></p>
        </div>
      </div>
      <!-- <div style="border-bottom: 2px solid #cccccc;width: 500px;height: 6px;position: absolute;left: 21%;bottom: 33.5%;">	
    		</div>
    		<div style="border-bottom: 2px solid #cccccc;width: 500px;height: 6px;position: absolute;left: 21%;bottom: 23.5%;">	
    		</div>
    		<div style="border-bottom: 2px solid #cccccc;width: 500px;height: 6px;position: absolute;left: 21%;bottom: 13%;">	
    		</div>
    		<div style="border-bottom: 2px solid #cccccc;width: 500px;height: 6px;position: absolute;left: 21%;bottom: 2.5%;">	
    		</div>
			<div class="About_Two" style="width: 450px;height: 389px;position: absolute;left: 50%;top: 65%;">

    		</div>
    		<div style="position: absolute; left: 86%;top: 59%;">
    			<img id="a4" src="../assets/images/About_Two.png" alt="" style="width: 450px;height: 389px;border: 1px solid  #ffffff">
    		</div> -->

      <div id="c" class="aboutwe_container about-fw">
        <h3 class="about-h3-fw">服务内容</h3>
        <div>
          <img src="../assets/images/About_Three.png" alt="" class="about-fw-img">
        </div>
        <div class="xzzc">
          <div class="about-fw-t1">
            <span style="font-size: 24px;">闲置资产 快速变现</span><br><br><br>
            <span>线上+线下的拍卖模式: 线上拍卖，线下预展。帮助企业中的闲置资产：二手设备、废旧物资、土地房产、工程机械、车辆房产、库存积压等通过竞价的方式实现快速变现。</span><br><br><br>
          </div>
          <div style="margin-left:36px;margin-right:20px;">
            <span style="font-size: 24px; ">有形无形 价格评估</span><br><br><br>
            <span>对有形资产，无形资产在特定点的价值（价格）进行分析、测算和判断并提供专业的意见和建议，保障委托人的利益。</span><br><br><br>
          </div>
          <div style="margin-left:36px;margin-right:20px;">
            <span style="font-size: 24px;">法律咨询 交易保障</span><br><br><br>
            <span>公司的法务部门，对于合同签署、相关资料、其他证明等，公司法务严格审核，并解决委托人，竞买人，买受人提出的法律相关的问题，对于向上支付，线下交易也会保障双方的利益.</span>
          </div>
        </div>

        <div class="ico1">
          <img style="width: 96px;height: 96px;" src="../assets/images/About_b1.png">
          <span></span>
        </div>
        <div class="ico2">
          <img style="width: 96px;height: 96px;" src="../assets/images/About_b2.png">
          <span></span>
        </div>
        <div class="ico3">
          <img style="width: 96px;height: 96px;" src="../assets/images/About_b3.png">
          <span></span>
        </div>

      </div>

      <div id="d" class="about-yy" style="">
        <h3 class="about-h3-yy">企业荣誉</h3>
        <div style="position: absolute;width: 100%">
          <img class="about-yy-img" src="../assets/images/About_Four.png">
          <span></span>
        </div>

        <div v-swiper:mySwiper="smSwiperOptionMobile">
          <div class="swiper-wrapper">
            <!-- margin-left:-374px;margin-left:-834px;margin-left:-827px; -->
            <div class="swiper-slide swiper-slide111">
              <img src="../assets/images/About_5.png" class="swiper-img">
              <img src="../assets/images/About_6.png" class="swiper-img">
              <img src="../assets/images/About_7.png" class="swiper-img">
            </div>

            <div class="swiper-slide swiper-slide111">
              <img src="../assets/images/About_8.png" class="swiper-img">
              <img src="../assets/images/About_9.png" class="swiper-img">
              <img src="../assets/images/About_10.png" class="swiper-img">
            </div>

            <div class="swiper-slide swiper-slide111">
              <img src="../assets/images/About_11.png" class="swiper-img">
              <img src="../assets/images/About_12.png" class="swiper-img">
            </div>
          </div>
          <div class="swiper-button-prev" style="top:60%;left:30px;"></div>
          <div class="swiper-button-next" style="top:60%;right:30px;"></div>
        </div>
      </div>

      <div id="e" class="aboutwe_container_Swiper" style="width: 100%;height: 833px;margin-top: 24px;position: relative;">
        <h3 class="about-h3-fz">发展历程</h3>
        <div>
          <span class="wenzi1">中拍协会员，吉林拍协会员全国范围内成立多家分公司.企业腾飞发展之年</span>
          <div class="yuan1"></div>
          <div class="xian1"></div>
          <span class="nian1">2020</span>
          <div style="position: absolute;"></div>
        </div>
        <div>
          <span class="wenzi2">获得拍卖行业资质</span>
          <div class="yuan2"></div>
          <div class="xian2"></div>
          <span class="nian2">2019</span>
        </div>
        <span class="wenzi3">全国科技行业自主创新五百强企业</span>
        <div class="y3"></div>
        <div class="xian3"></div>
        <div>
          <span class="nian3">2018</span>
        </div>
        <div>
          <span class="wenzi4">吉林AAAAA级诚信企业</span>
          <div class="yuan4"></div>
          <div class="xian4"></div>
          <span class="nian4">2017</span>
        </div>
        <div>
          <span class="wenzi5">国家互联网电子商务诚信示范企业</span>
          <div class="yuan5"></div>
          <div class="xian5"></div>
          <span class="nian5">2016</span>
        </div>
        <div>
          <span class="wenzi6">建立中国拆迁网</span>
          <div class="yuan6"></div>
          <div class="xian6"></div>
          <span class="nian6">2015</span>
        </div>
        <div>
          <span class="wenzi7">公司成立注册资本2189万</span>
          <div class="yuan7"></div>
          <div class="xian7"></div>
          <span class="nian7">2014</span>
        </div>

      </div>

      <div class="aboutwe_container hehuoren" style="width: 100%;height:auto;margin-top: 20px;position: relative;">
        <div class="problem">
          <!-- PC端 -->
          <div class="problem_left" id="f">
            <h3 class="about-h3-lx">联系我们</h3>
            <ul class="problem_left_title">
              <li><a href="/partner">招募合伙人</a></li>
              <li><a>拍界总部信息</a></li>
              <li style="padding-left:40px;" v-for="(item,indexli) in companies2" :key="indexli" @click="toggleproTabs(indexli,0)" :class='{ current : showLi == indexli && showUl == 0 }'>{{item.title}}</li>
              <li><a>拍界分部信息</a></li>
              <li style="padding-left:40px;" v-for="(item,indexli) in branch_companies" :key="indexli" @click="toggleproTabs(indexli,1)" :class='{ current : showLi == indexli && showUl == 1 }'>{{item.title}}</li>
            </ul>
          </div>
          <div class="problem_right">
            <ul class="problem_right_container" v-show="showUl === 0">
              <li class="problem_right_title">拍界总部信息</li>
              <!-- <li v-for="(item,indexli) in companies2" v-show="showLi === indexli"> -->
              <li v-for="(item, indexli) in companies2" v-show="showLi === indexli" :key="indexli">
                {{item.title}}
                <p v-if="item.name != undefined">联系人：{{item.name}}</p>
                <p>联系电话：{{item.phone}}</p>
                <p>地址：{{item.address}}</p>
                <p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
                <!-- <img v-for="image in JSON.parse(item.images)" :src="image.url" alt=""> -->
                <img v-for="(image, index) in JSON.parse(item.images)" :key="index" :src="image.url" :alt="image.alt">
                <div id="container" class="mymap" style="height:600px">
                  <el-amap :center='center' :zoom='zoom'>
                    <el-amap-marker v-for="marker in markers" :key="marker.id" :position="marker.position" :label="marker.label" :events="marker.events">
                    </el-amap-marker>

                    <el-amap-info-window v-for="window in windows" :key="window.id" :position="window.position" :content="window.content" :visible="window.visible" :events="window.events">
                    </el-amap-info-window>
                  </el-amap>
                </div>
              </li>

            </ul>
            <ul class="problem_right_container" v-show="showUl === 1">
              <li class="problem_right_title">拍界分部信息</li>
              <!-- <li v-for="(item,indexli) in branch_companies" v-show="showLi === indexli"> -->
              <li v-for="(item, indexli) in branch_companies" v-show="showLi === indexli" :key="item.id">
                {{item.title}}
                <p v-if="item.name != undefined">联系人：{{item.name}}</p>
                <p>联系电话：{{item.phone}}</p>
                <p>地址：{{item.address}}</p>
                <p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
                <!-- <img v-for="image in JSON.parse(item.images)" :src="image.url" alt=""> -->
                <img v-for="(image, index) in JSON.parse(item.images)" :key="index" :src="image.url" :alt="image.alt">
                <div id="container" class="mymap" style="height:600px">
                  <el-amap :center='center' :zoom='zoom'>
                    <el-amap-marker v-for="marker in markers" :key="marker.id" :position="marker.position" :label="marker.label" :events="marker.events">
                    </el-amap-marker>

                    <el-amap-info-window v-for="window in windows" :key="window.id" :position="window.position" :content="window.content" :visible="window.visible" :events="window.events">
                    </el-amap-info-window>
                  </el-amap>
                </div>
              </li>

            </ul>
          </div>
          <!-- 移动端
		<div class="problem_phone">
			<ul class="problem_left_title" >
				<li class="problem_left_titles"><a href="/partner">招募合伙人</a></li>
				<li class="problem_left_titles">拍界总部信息</li>
				<li v-for="(item,indexli) in companies">{{item.title}}
					<ul class="problem_phone_content">
						<li>
							<p v-if="item.name != undefined">联系人：{{item.name}}</p>
							<p>联系电话：{{item.phone}}</p>
							<p>地址：{{item.address}}</p>
							<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
							<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
						</li>
					</ul>
				</li>
				<li class="problem_left_titles">拍界分部信息</li>
				<li v-for="(item,indexli) in branch_companies">{{item.title}}
					<ul class="problem_phone_content">
						<li>
							<p v-if="item.name != undefined">联系人：{{item.name}}</p>
							<p>联系电话：{{item.phone}}</p>
							<p>地址：{{item.address}}</p>
							<p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
							<img v-for="image in JSON.parse(item.images)" :src="image.url" alt="">
						</li>
					</ul>
				</li>
			
			</ul>
		</div> -->
        </div>
      </div>

      <!-- <div class="aboutwe_container_text1">
				<div class="aboutwe_container_text1_left">
					<div class="aboutwe_text2">""
						<div>
							<h5>企业荣誉</h5>
							<p>吉林省AAAAA级企业</p>
							<p>中国互联网电子商务诚信示范企业</p>
							<p>国家一级中国科技行业资质等级证书</p>
							<p>国家一级中国科技行业资质等级证书</p>
							<p>登录央视广告</p>
							<p>吉林省拍卖协会会员</p>
							<p>中国拍卖协会会员</p>
							<p>全国科技行业自主创新500强</p>
						</div>
						<div>
							<h5>拍界服务</h5>
							<p>完备的线下服务体系“拍界”拥有精准客户群体，可以提供多种网上竞价的功能，还能提供专业完备的线下服务，“拍界”具有专业完备的线下服务体系。中国拍卖行业协会近2800余家会员单位，全国近7300余家拍卖企业,13000多名拍卖师，近20多万拍卖从业人员都是“拍界”的坚强后盾，可为委托单位、竞买群体、买受人提供优质的线下服务，完善的线下服务以及后期延续服务在全国范围内可无死角的延伸。</p>
						</div>
					</div>
				</div>
				<div class="aboutwe_container_text1_right"><img src="../assets/images/about_bg2.png" alt=""></div>
			</div> -->
      <!-- <div class="aboutwe_container">
				<h3 id='c'>服务内容</h3>
				<div class="line"></div>
				<p>拍界在2020年火力全开，将更多简单便捷的平台政策送给用户，全方位开拓参拍者的拍卖之路。在疫情防护解除过去的半个月里，便有无数参拍者踊跃报名，把握拍卖时代风口，迎风破浪，共赴亿万蓝海。</p>
			</div>
			<div class="aboutwe_container">
				<h3 id='d'>拍界战略</h3>
				<div class="line"></div>
				<p>专业化服务队伍“拍界”有专业的技术支撑，自主创新强,研发多种网络拍卖方式，拍界有着强大的行业支持和资金支持，有着国内顶级的网络技术团队，随时根据市场的需求、企业的需求客户的需求进行系统的升级迭代、更新维护，使平台在保持专业性、稳定性的同时更人性化。</p>
			</div> -->
      <!-- <div id="container" class="mymap" style="height:600px">
				<el-amap :center='center' :zoom='zoom'>
			      	<el-amap-marker 
			      		v-for="marker in markers" 
			      		:position="marker.position" 
			      		:label="marker.label" 
			      		:events="marker.events">
			      	</el-amap-marker>
			
			      	<el-amap-info-window
			      		v-for="window in windows" 
						:position="window.position"
						:content="window.content"
						:visible="window.visible"
						:events="window.events">
	              	</el-amap-info-window>
			    </el-amap>
			</div> -->
      <!-- <div class="aboutwe_container">
				<h3>加入拍界</h3>
				<div class="line"></div>
				<p>拍界真诚欢迎各位使用，拍界为您提供全面的二手设备，废旧金属、废旧电子电器等商品。公司诚信经营，以品质第一作为发展的第一准则，以热情周到的态度为您服务，让我们携手，走向拍卖经典时代！</p>
			</div>
			<div class="about_bottom">
				<div >期待您的合作！</div>
			</div> -->
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "拍界_拍卖无边界",
    meta: [{
      name: "keywords",
      content: "拍界，拍界App，拍界官网，捡漏，拍卖，拍卖网，拍卖会，手机拍卖，微拍，微信拍卖，寻宝，收藏，拆除，二手设备，工厂，废旧物资，再生资源，回收，法拍房，法拍车，房产，司法拍"
    }, {
      name: "description",
      content: "拍界经典新时代，拍卖无边界，拍卖更便捷"
    }]
  },
  data () {
    return {
      markers: [],
      showUl: 0,
      showLi: 0,
      windows: [],
      window: '',
      center: [123.436306609848, 42.81915342906472],
      zoom: 5,
      companies: [],
      companies2: [],
      smSwiperOptionMobile: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000,                      // 几秒播放一次
          disableOnInteraction: false       // 手动滑动后是否停止自动播放
        },
        loop: true,
        speed: 300									// 滚动速度
      },
      branch_companies: [],
    }


  },
  created () {

    // 接收路由参数
    const curLi = this.$route.query.curLi;
    const curUl = this.$route.query.curUl;
    if (curLi !== undefined && curUl !== undefined) {
      this.toggleproTabs(curLi, curUl)
    }

    this.axios.get("https://api.paijie.com/companies")
      .then((response) => {
        if (response.data.error.code == 0) {
          this.branch_companies = response.data.branch_companies;
          this.companies2 = response.data.companies;
          this.companies = this.branch_companies.concat(this.companies2);
          this.setMarkers(this.companies);
        }
      })
      .catch(() => { });

    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)


  },

  // 方法属性
  methods: {
    setMarkers: function (companies) {
      let markers = [];
      let windows = [];
      let self = this;

      for (let i = 0; i < companies.length; i++) {
        markers.push({
          position: [companies[i].lng, companies[i].lat],
          label: {
            content: companies[i].title,
            offset: [20, 22]
          },
          events: {
            mouseover () {
              self.windows.forEach(window => {
                window.visible = false;
              });

              self.window = self.windows[i];
              self.$nextTick(() => {
                self.window.visible = true;
              });
            }
          }
        });

        if (companies[i].name == null) {
          companies[i].name = '拍界客服';
        }

        windows.push({
          position: [companies[i].lng, companies[i].lat],
          content:
            `<div class="prompt">
	            		公司：${companies[i].title}
	            	</div>
	            	<div class="prompt">
	            		电话：${companies[i].phone}
	            	</div>
	            	<div class="prompt">
	            		联系人：${companies[i].name}
	            	</div>
	            	<div class="prompt">
	            		位置：${companies[i].address}
	            	</div>`,
          visible: false,
        });
      }

      this.markers = markers;
      this.windows = windows;
    },

    // tab切换
    toggleproTabs: function (showLi, showUl) {
      this.showLi = showLi;
      this.showUl = showUl;
    }

  },
  mounted () {
    // 不是移动端则页面至顶部
    if (this.$route.query.isMobile == false) {
      window.scrollTo(0, 0)
    }

  },
  computed: {

  },

  // var infoWindow = new BMap.InfoWindow("地址：北京市东城区王府井大街88号乐天银泰百货八层", opts);  // 创建信息窗口对象
  //           marker.addEventListener("click", function () {
  //               map.openInfoWindow(infoWindow, point); //查看当前事件对象
  //           });
}
</script>